export const labelDiscountCodeGiftCard = (useGiftCard, useDiscountCode) => {
  if (useGiftCard && useDiscountCode) return 'Cupón de descuento o Gift card'
  else if (useGiftCard) return 'Gift card'
  else return 'Cupón de descuento'
}
